import React, { Component } from 'react';
import PropTypes from 'prop-types';

import TableHead from './tableHead';
import ActionRow from './actionRow';
import TableBody from './tableBody';
import TableFoot from './tableFoot';

// import './style.scss'; // TODO - move this styling somewhere?

// =============== //
// TABLE COMPONENT //
// =============== //
export default class Table extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mobile: false,
      minWidth: '0',
      width: '0',
      height: '0'
    };

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    const { columns, actions } = this.props;
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);

    let minWidth = 0;
    if (actions !== null) {
      minWidth += parseInt(actions.minWidth, 10);
    }
    columns.forEach((column) => {
      for (const key in column) {
        if (column.hasOwnProperty(key)) {
          if (key === 'minWidth') minWidth += parseInt(column[key], 10);
        }
      }
    }, this);

    this.setState(() => ({ minWidth }));
  }

  componentDidUpdate() {
    const { mobile, minWidth, width } = this.state;

    if (!mobile && width <= minWidth) {
      this.setState(() => ({ mobile: true }));
    } else if (mobile && width > minWidth) {
      this.setState(() => ({ mobile: false }));
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  renderHeader() {
    const { actions, columns, classes, showHeader } = this.props;
    const { mobile } = this.state;

    if (showHeader === false) return null;
    return <TableHead actions={actions} mobile={mobile} columns={columns} />;
  }

  renderActionRow() {
    const { actionRow } = this.props;
    const { mobile } = this.state;

    if (actionRow === false) return null;
    return <ActionRow actions={actionRow} mobile={mobile} />;
  }

  renderRows() {
    const { classes, data, columns, actions, clickCell, hoverCell, clickRow, hoverRow, clickColumn, hoverColumn } =
      this.props;
    const { mobile } = this.state;

    return (
      <TableBody
        mobile={mobile}
        data={data}
        columns={columns}
        // Custom columns
        actions={actions}
        // Functions
        clickCell={clickCell}
        hoverCell={hoverCell}
        clickRow={clickRow}
        hoverRow={hoverRow}
        clickColumn={clickColumn}
        hoverColumn={hoverColumn}
      />
    );
  }

  renderFooter() {
    const { columns, classes, className, showFooter, actions } = this.props;
    const { mobile } = this.state;

    if (showFooter === false) return null;
    return <TableFoot actions={actions} mobile={mobile} columns={columns} />;
  }

  render() {
    const { data, classes, className } = this.props;
    const { mobile } = this.state;

    if (data === false) return null;

    return (
      <div
        className={`ui-table ${classes} ${className !== '' ? `ui-table--${className}` : ''} ${
          mobile ? 'ui-table--is-mobile' : ''
        } `}
      >
        {this.renderHeader()}
        {this.renderActionRow()}
        {this.renderRows()}
        {this.renderFooter()}
      </div>
    );
  }
}
Table.defaultProps = {
  data: false,
  columns: null,
  classes: '',
  className: '',
  showHeader: true,
  showFooter: false,
  // custom columns
  actions: null,
  // custom rows
  actionRow: null,
  // Functions
  clickCell: null,
  hoverCell: null,
  clickRow: null,
  hoverRow: null
};

Table.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  classes: PropTypes.string,
  columns: PropTypes.array,
  showHeader: PropTypes.bool,
  showFooter: PropTypes.bool,
  // custom columns
  actions: PropTypes.shape({
    head: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    cell: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    foot: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    classes: PropTypes.string,
    className: PropTypes.string,
    minWidth: PropTypes.string.isRequired
  }),
  // custom row
  actionRow: PropTypes.func,
  // Functions
  clickCell: PropTypes.func,
  hoverCell: PropTypes.func,
  clickRow: PropTypes.func,
  hoverRow: PropTypes.func
};
